import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://vivahc.azurewebsites.net/AMYRA'
    // baseURL: 'test'
});

export default instance;
